// extracted by mini-css-extract-plugin
export default {"PermissionsDiv":"IFGroupingComponent_PermissionsDiv__kY0E8","RenderText":"IFGroupingComponent_RenderText__pU6q-"};